import { useQuery } from '@tanstack/vue-query';
import { queries } from '@/keys';
import type { User } from '~/types/auth';

const useAgent = (enabled?: boolean) => {
  const authStore = useAuthStore();

  // Make sure we have a valid user ID, and provide a fallback that satisfies the typing requirements
  const userId = authStore.user?.id || 0;

  return useQuery({
    ...queries.users.agent(userId),
    queryFn: async () => {
      if (!authStore.token || !authStore.getUser?.leadId) return null;
      if (authStore.agent) return authStore.agent as User;
      authStore.updateAgentLoading(true);
      try {
        const result = await $fetch<User>(`/api/user/${authStore.user?.id}/agent`, {
          headers: {
            Authorization: `Bearer ${authStore.token}`,
          },
        });

        return result || null; // Ensure we return null instead of undefined
      } catch (error) {
        console.error('Error fetching agent:', error);
        return null; // Return null on error
      } finally {
        authStore.updateAgentLoading(false);
      }
    },
    enabled,
    retry: false,
    select: (data) => {
      if (!data) return null;

      // Update agent with data directly since it's already an object
      authStore.updateAgent(data);
      return data;
    },
  });
};

export default useAgent;
